import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomPriceRankGetNewPriceRankItem_RoomPriceRankPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchNewPriceRankItem = ({ hotelID }: Props) => {
	const { refetch } = useCustomSuspenseQuery(RoomPriceRankGetNewPriceRankItem_RoomPriceRankPage_Query, {
		variables: { hotelID },
	});

	return {
		refetch,
	};
};
